export const initialState:any = {
    Id: -1,
    SMRId: -1,
    AgreementSignOffDate: "",
    AgreementId: -1,
    Agreement: "",
    Image: "",
    IsSigned: false
}